import { SpexNode } from '../types/playbook.type'
import { axiosInstance } from './axios.service'
import { IResponse } from '../types/response.type'
import { NodeEndpoints } from '../types/endpoint.type'
import {
  INodeRequest,
  INodeResponse,
} from '../../shared/types/api/playbook.type'

export const createNode = async (
  playbook_id: number,
  node: SpexNode,
): Promise<INodeResponse> => {
  const req: INodeRequest = {
    playbook_id: playbook_id,
    x: node.position.x,
    y: node.position.y,
    type: node.type!,
    view: node.view,
    data: node.data,
  }
  const resp = await axiosInstance.post(NodeEndpoints.CREATE, req)

  return resp.data
}

export const updateNode = async (
  node: SpexNode,
): Promise<IResponse<SpexNode>> => {
  try {
    const data = await axiosInstance.put(NodeEndpoints.UPDATE + node.id, node)

    return data.data
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}
